import { message } from 'antd'
import { PackageApi } from '../../../../api/Purchase/Package'
import DeliveryStops from '../../../../components/Purchasing/Packages/Stops/DeliveryStops'
import { pick } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function DeliveryStopsCont (props) {
  const { packageObj, isUpdatable } = props
  const { list, fetching, fetch } = useFetchList(() =>
    PackageApi.getLinesByPackage(packageObj._key),
  )

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, PackageApi.lines.update, PackageApi.lines.remove, undefined)

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await PackageApi.lines.create({
        ...newObject,
        delivery: pick(packageObj, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <DeliveryStops
      {...{
        list,
        isUpdatable,
        fetching,
        fetch,
        visible,
        submitting,
        packageObj,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

DeliveryStopsCont.propTypes = {}
DeliveryStopsCont.defaultProps = {}

export default (DeliveryStopsCont)
